<template>
  <div class="job-poster">
    <div class="header">
      <el-row type="flex" align="middle">
        <el-col :span="12">
          <div class="header-left">
            <span class="text">{{ $t('admin.company.jobPoster.label.posterTitle') }}</span>
            <el-input v-model="jobPosterType.title" maxlength="64"></el-input>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="header-right">
            <span class="poster-select">
              <span :class="isCnPoster && 'poster-language-selected'" @click="posterLanguageSelect(isCnPoster,true)">中文</span>
              <el-divider direction="vertical"></el-divider>
              <span :class="!isCnPoster && 'poster-language-selected'" @click="posterLanguageSelect(!isCnPoster,false)">English</span>
            </span>
            <span class="status-container">
              <el-switch
                v-model="posterEditData.is_enabled"
                active-color="#13ce66"
                :active-text="$t('admin.company.jobPoster.label.on')"
                :inactive-text="$t('admin.company.jobPoster.label.off')"
                :width="65"
              >
              </el-switch>
            </span>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-divider></el-divider>
    <div class="content">
      <div class="poster-management">
        <!-- 视频海报独有的设置 -->
        <div v-if="isVideoPoster" class="poster-bg-img poster-video">
          <el-row type="flex" align="middle" :gutter="5">
            <el-col :span="4">
              <span class="title">{{ $t('admin.company.jobPoster.label.posterVideo') }}</span>
            </el-col>
            <el-col :span="4">
              <el-tooltip placement="top-start" :hide-after="1500">
                <div slot="content">{{ $t('admin.company.jobPoster.label.acceptVideoType') }}<br/>
                {{ $t('admin.company.jobPoster.label.acceptVideoSize', { videoMaxSize: acceptVideoSize, videoMaxDuration: acceptVideoDuration }) }}</div>
                <input class="upload-btn" type="button" :value="$t('admin.company.jobPoster.label.uploadFile')" @click="handleUploadVideoBtnClick()">
              </el-tooltip>
              <input
                v-show="false"
                ref="videoFile"
                type="file"
                :disabled="videoIsUploading"
                :accept="acceptVideoType"
                @change="handleVideoFileChange()"
              />
            </el-col>
            <el-col v-show="compressedVideoTempUrl" :span="8">
              <span>
                {{ $t('admin.company.jobPoster.label.currentVideoSize') }}: {{ videoInfo.width }} x {{ videoInfo.height }}
              </span>
            </el-col>
            <el-col v-show="videoIsUploading" :span="4">
              <span class="upload-tip">{{ $t('admin.company.jobPoster.message.uploading') }}</span>
            </el-col>
          </el-row>
        </div>
        <div v-show="false" class="video-container">
          <video controls :src="videoTempUrl" @loadedmetadata="onVideoLoaded"></video>
        </div>
        <div v-show="compressedVideoTempUrl" class="video-container">
          <video controls :src="compressedVideoTempUrl"></video>
        </div>
        <div v-if="isVideoPoster" class="poster-bg-img poster-video-type">
          <el-row type="flex" align="middle" :gutter="5">
            <el-col :span="4">
              <span class="title">
                {{ $t('admin.company.jobPoster.label.posterType') }}
              </span>
            </el-col>
            <el-col :span="8">
              <el-select v-model="videoPosterType" class="poster-type-selector">
                <el-option
                  v-for="item in videoPosterTypes"
                  :label="getVideoPosterTypeName(item.name)"
                  :value="item.type"
                  :key="item.id"
                >
                </el-option>
              </el-select>
              <el-tooltip class="item" effect="dark" placement="right" :content="$t('admin.company.jobPoster.message.bindImageTip')">
                <i class="notice-icon el-icon-warning"></i>
              </el-tooltip>
            </el-col>
          </el-row>
        </div>
        <!-- 图片海报相关设置 -->
        <div class="poster-bg-img">
          <el-row type="flex" align="middle" :gutter="5">
            <el-col :span="4">
              <span class="title">
                {{ $t(`admin.company.jobPoster.label.${isVideoPoster ? 'imageSize' : 'posterSize'}`) }}
              </span>
            </el-col>
            <el-col :span="3">
              <el-input
                v-model="posterEditData.bg_size.X"
                type="number"
                min="0"
                placeholder="X"
              >
              </el-input>
            </el-col>
            <el-col :span="3">
              <el-input
                v-model="posterEditData.bg_size.Y"
                placeholder="Y"
                type="number"
                min="0"
              >
              </el-input>
            </el-col>
            <el-col :span="5">
              <el-tooltip placement="top-start" :hide-after="1500">
                <div slot="content">{{ $t('admin.company.jobPoster.label.acceptImageType') }}<br/>
                {{ $t('admin.company.jobPoster.label.acceptImageSize', { imageMaxSize: acceptImageFileSize }) }}</div>
                <input type="button" class="upload-btn" :value="$t('admin.company.jobPoster.label.uploadFile')" @click="handleUploadBtnClick(true)">
              </el-tooltip>
              <i v-show="hasBgImage" :class="['upload-status-icon', 'el-icon-success']"></i>
              <input
                v-show="false"
                ref="bgImageFile"
                type="file"
                :accept="acceptImageFileType"
                @change="handleImageFileChange(true)"
              />
            </el-col>
          </el-row>
        </div>
        <div class="poster-share-img">
          <el-row type="flex" align="middle" :gutter="5">
            <el-col :span="6">
              <span class="title">{{ $t('admin.company.jobPoster.label.shareCoverImage') }}</span>
            </el-col>
            <el-col :span="4">
            </el-col>
            <el-col :span="5">
              <el-tooltip placement="top-start" :hide-after="1500">
                <div slot="content">{{ $t('admin.company.jobPoster.label.acceptImageType') }}<br/>
                {{ $t('admin.company.jobPoster.label.acceptImageSize', { imageMaxSize: acceptImageFileSize }) }}</div>
                <input class="upload-btn" type="button" :value="$t('admin.company.jobPoster.label.uploadFile')" @click="handleUploadBtnClick(false)">
              </el-tooltip>
              <i v-show="hasShareImage" :class="['upload-status-icon', 'el-icon-success']"></i>
              <input
                v-show="false"
                ref="shareImageFile"
                type="file"
                :accept="acceptImageFileType"
                @change="handleImageFileChange(false)"
              />
            </el-col>
            <el-col :span="8" class="img-tips">
              {{ $t('admin.company.jobPoster.label.imgRecommended', {
                recommendedSize: isVideoPoster ? $t('admin.company.jobPoster.label.sameAsVideoSize') : '150x198 px'
              }) }}
            </el-col>
          </el-row>
        </div>
        <div class="select-poster-show-type">
          <span class="label">{{ $t(`${i18nPrefix}.label.jobPosterShowType`) }}</span>
          <el-select v-model="posterShowType">
            <el-option
              v-for="item in posterShowTypeOptions"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="poster-text">
          <el-table
            class="poster-text-table"
            border
            :data="posterEditData.content_configuration"
            :header-cell-style="headerCellStyle"
            :cell-style="cellStyle"
            :row-style="rowStyle"
          >
            <el-table-column
              fixed
              width="110"
              align="center"
              :label="$t('admin.company.jobPoster.label.fieldValue')"
            >
              <template slot-scope="scope">
                <span class="filed-value">{{ $t(`admin.company.jobPoster.label.${scope.row.name}`) }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('admin.company.jobPoster.label.operation')">
              <template slot-scope="scope">
                <el-row type="flex" align="middle" :gutter="5">
                  <el-col :span="3">
                    <el-input
                      v-model="scope.row.data.X"
                      type="number"
                      min="0"
                      placeholder="X"
                    ></el-input>
                  </el-col>
                  <el-col :span="3">
                    <el-input
                      v-model="scope.row.data.Y"
                      type="number"
                      min="0"
                      placeholder="Y"
                    ></el-input>
                  </el-col>
                  <el-col :span="4">
                    <el-input
                      v-model="scope.row.data.MaxWidth"
                      type="number"
                      min="0"
                      placeholder="Max Width"
                    ></el-input>
                  </el-col>
                  <el-col class="is-text-center" :span="5">
                    <input v-model="scope.row.data.centerAlign" class="checkbox" type="checkbox" value="true" />
                    <span class="qr-text">{{ $t('admin.company.jobPoster.label.align.center') }}</span>
                  </el-col>
                  <el-divider direction="vertical"></el-divider>
                  <el-col :span="3">
                    <el-dropdown trigger="click" placement="bottom" @command="handleFontSelect($event,scope.$index,'font')">
                      <span class="el-dropdown-link poster-dropdown-select" :title="$t('admin.company.jobPoster.label.font')">
                        <span class="dropdown-text-area">{{ scope.row.data.font ? (scope.row.data.font === 'followTheme' ? $t(`${i18nPrefix}.label.followTheme`) : scope.row.data.font) : $t('admin.company.jobPoster.label.font')}}</span>
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown" class="font-select">
                        <el-dropdown-item command="">{{ $t('admin.company.jobPoster.label.font') }}
                        </el-dropdown-item>
                        <el-dropdown-item
                          v-for="(item, index) in fontList"
                          :command="item"
                          :style="{'font-family':item}"
                          :value="item"
                          :key="index"
                        >
                          {{ item }}
                        </el-dropdown-item>
                        <el-dropdown-item command="followTheme">{{ $t(`${i18nPrefix}.label.followTheme`) }}</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </el-col>
                  <el-divider direction="vertical"></el-divider>
                  <el-col :span="3">
                    <el-dropdown trigger="click" placement="bottom" @command="handleFontSelect($event, scope.$index, 'size')">
                      <span class="el-dropdown-link poster-dropdown-select">
                        <el-input
                          v-model="scope.row.data.size"
                          class="dropdown-text-area"
                          :placeholder="$t('admin.company.jobPoster.label.size')"
                          @input="formatFontSize($event, scope.row.data)"
                        ></el-input>
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown" class="font-size-select">
                        <el-dropdown-item
                          v-for="(item,index) in fontSizeList"
                          :command="item"
                          :key="index"
                          :style="{'font-size':item+'px','line-height':(item + 8) + 'px'}"
                          :value="item">{{ item }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </el-col>
                  <el-divider direction="vertical"></el-divider>
                  <el-col :span="2">
                    <div class="color-picker">
                      <div class="color-picker-text">A</div>
                      <el-color-picker v-model="scope.row.data.color" value='color' size="small"></el-color-picker>
                    </div>
                  </el-col>
                  <el-divider direction="vertical"></el-divider>
                  <el-col :span="1">
                    <el-button class="font-bold-option" type="text" :style="scope.row.data.fontBold && 'font-weight: bold'" @click="scope.row.data.fontBold=!scope.row.data.fontBold">B</el-button>
                  </el-col>
                  <el-col :span="2">
                    <span class="status-container">
                      <el-switch
                        v-model="scope.row.data.status"
                        active-color="#13ce66"
                        :active-text="$t('admin.company.jobPoster.label.on')"
                        :inactive-text="$t('admin.company.jobPoster.label.off')"
                        :width="57"
                      ></el-switch>
                    </span>
                  </el-col>
                </el-row>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="poster-qrcode">
          <div class="poster-qrcode-size">
            <el-row type="flex" align="middle" :gutter="1">
              <el-col :span="5">
                <span class="qr-text">{{ $t('admin.company.jobPoster.label.qrCodeSize') }}</span>
              </el-col>
              <el-col :span="3">
                <el-input
                  v-model="posterEditData.qrcode_configuration.width"
                  type="number"
                  min="0"
                  placeholder="width"
                ></el-input>
              </el-col>
              <el-col :span="4">
              </el-col>
              <el-col :span="6">
                <span class="qr-text">{{ $t('admin.company.jobPoster.label.qrCodePosition') }}</span>
              </el-col>
              <el-col :span="3">
                <el-input
                  v-model="posterEditData.qrcode_configuration.X"
                  type="number"
                  min="0"
                  placeholder="X"
                ></el-input>
              </el-col>
              <el-col :span="3">
                <el-input
                  v-model="posterEditData.qrcode_configuration.Y"
                  type="number"
                  min="0"
                  placeholder="Y"
                ></el-input>
              </el-col>

            </el-row>
          </div>
          <div class="poster-qrcode-size">
            <el-row type="flex" align="middle" :gutter="5">
              <el-col :span="5">
                <span class="qr-text">{{ $t('admin.company.jobPoster.label.qrCodeDisplay') }}</span>
              </el-col>
              <el-col :span="7">
                <input v-model="posterEditData.qrcode_configuration.roundedCorners" type="checkbox" value="true" />
                <span class="qr-text">{{ $t('admin.company.jobPoster.label.roundedCorners') }}</span>
              </el-col>
              <el-col :span="6">
                <span class="qr-text">{{ $t('admin.company.jobPoster.label.haveLogo') }}</span>
              </el-col>
              <el-col :span="3">
                <input v-model="posterEditData.qrcode_configuration.haveLogo" type="radio" :value="true" />
                <span class="qr-text">{{ $t('admin.company.jobPoster.label.yes') }}</span>
              </el-col>
              <el-col :span="3">
                <input v-model="posterEditData.qrcode_configuration.haveLogo" type="radio" :value="false" />
                <span class="qr-text">{{ $t('admin.company.jobPoster.label.no') }}</span>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="bottom-btn-group adapt-wrapper" v-if="isVideoPoster">
          <el-button class="cancel-btn blue-btn" @click="back">{{ $t('common.btn.back') }}</el-button>
          <el-button class="cancel-btn blue-btn" @click="handlePreview">{{ $t('admin.company.jobPoster.label.previewPicture') }}</el-button>
          <el-button class="cancel-btn blue-btn" :disabled="videoIsUploading" @click="handlePreviewVideo">{{ $t('admin.company.jobPoster.label.previewVideo') }}</el-button>
          <span v-show="videoIsGenerating" class="cancel-btn blue-btn">{{ $t('admin.company.jobPoster.message.generating') }}</span>
          <el-button v-debounce="[handleSave]" class="save-btn blue-btn" :disabled="videoIsUploading || isSaving">{{ $t('admin.company.jobPoster.label.save') }}</el-button>
        </div>
        <div class="bottom-btn-group adapt-wrapper" v-else>
          <el-button class="cancel-btn blue-btn" @click="back">{{ $t('common.btn.back') }}</el-button>
          <el-button class="cancel-btn blue-btn" @click="handlePreview">{{ $t('admin.company.jobPoster.label.preview') }}</el-button>
          <el-button v-debounce="[handleSave]" class="save-btn blue-btn" :disabled="isSaving">{{ $t('admin.company.jobPoster.label.save') }}</el-button>
        </div>
        <RectLoading v-show="showLoadingBox"/>
      </div>
      <div class="poster-preview">
        <div v-show="posterPreviewShow" class="poster-img">
          <img width="500px" :height="previewHeight" :src="previewPosterUrl">
        </div>
        <div v-show="posterVideoPreviewShow" class="poster-img">
          <video width="500px" controls :src="previewVideoTempUrl"></video>
        </div>
      </div>
      <vue-qr
        :bind-element="false"
        :logoSrc='previewQrcode.logoSrc'
        :text="previewQrcode.text"
        :size="200"
        :callback="savePreviewQRcodeUrl"
      ></vue-qr>
      <vue-canvas-poster
        :widthPixels="1000"
        :painting="painting"
        @success="successCreateImg"
        @fail="fail"
      >
      </vue-canvas-poster>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import {
  ACCEPT_FILE_TYPE, ACCEPT_FILE_SIZE, FONT_FAMILY_LIST, FONT_SIZE_LIST,
  ACCEPT_VIDEO_FILE_TYPE, ACCEPT_VIDEO_DURATION_SECONDS, ACCEPT_VIDEO_FILE_SIZE, JOB_POSTER_SHOW_TYPE
} from '@/constant/jobPoster'
import VueQr from 'vue-qr'
import { VueCanvasPoster } from 'vue-canvas-poster'
import RectLoading from '@/components/loading/rectLoading'
import _ from 'lodash'
import { resizeDataURL, dataUrlToFile, uploadBase64Src, getBindImageHeight, preCompressImage, uploadFile as uploadFileUtil } from '@/utils/qiniu'

const LOCAL_FILE_KEY = 'ajinga_poster_source'

export default {
  beforeRouteLeave (to, from, next) {
    if (!this.isSavePosterDataCN || !this.isSavePosterDataEN) {
      this.$confirm(this.$t('common.message.unSaveChangeConfirm'), '', {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        next()
      }).catch(() => {
        next(false)
      })
    } else {
      next()
    }
  },
  metaInfo () {
    return {
      link: this.fontStyle.fontLinkList,
      style: [{
        innerHTML: this.fontStyle.fontFace
      }]
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.company.jobPoster',
      cellStyle: { 'border-color': '#8c8c8d', 'text-align': 'center', padding: '8px 15px 8px 10px' },
      headerCellStyle: { 'border-color': '#8c8c8d', 'background-color': '#ddd', color: '#626365', 'text-align': 'center' },
      acceptImageFileType: ACCEPT_FILE_TYPE,
      acceptImageFileSize: ACCEPT_FILE_SIZE / (1024 * 1024),
      acceptVideoType: ACCEPT_VIDEO_FILE_TYPE,
      acceptVideoDuration: ACCEPT_VIDEO_DURATION_SECONDS,
      acceptVideoSize: ACCEPT_VIDEO_FILE_SIZE / (1024 * 1024),
      fontList: FONT_FAMILY_LIST,
      fontSizeList: FONT_SIZE_LIST,
      isCnPoster: true,
      isSavePosterDataCN: true,
      isSavePosterDataEN: true,
      isSaving: false,
      isChangeLanguage: true,
      showLoadingBox: false,
      uploadImg: {
        fileKeyPrefix: 'job-poster/',
        token: null,
        imgFileCN: {},
        imgFileEN: {}
      },
      uploadVideo: {
        fileKeyPrefix: 'job-poster/',
        token: null,
        fileCN: {},
        fileEN: {},
        file: null
      },
      videoInfo: {
        width: 0,
        height: 0,
        duration: 0
      },
      videoPosterTypes: [
        { id: 1, type: 'up', name: 'videoTopImage' },
        { id: 2, type: 'down', name: 'videoBottomImage' }
        // { id: 3, type: 'tail', name: 'videoBindImage' }
      ],
      hasBgImage: false,
      hasShareImage: false,
      companyVideoKeyMap: { cn: {}, en: {} }, // { cn: { company_id1: key }, en: { company_id1: key } }
      videoIsUploading: false,
      videoIsGenerating: false,
      videoPosterType: 'down',
      compressedVideoTempUrl: '',
      videoTempUrl: '',
      previewVideoTempUrl: '', // 点击视频预览时合成图片和视频后的视频
      posterVideoPreviewShow: false,
      needBreakOption: false,
      color: '#0A0A0A',
      companyList: [],
      selectCompany: null,
      posterEditData: {
        poster_type: '',
        is_enabled: true,
        bg_size: {
          X: '',
          Y: ''
        },
        bg_source_url: '',
        watermark_bg_url: '',
        watermark_bg_location: '',
        share_img_url: '',
        qrcode_configuration: {
          X: '',
          Y: '',
          width: '',
          haveLogo: false,
          roundedCorners: false
        },
        content_configuration: [{
          name: 'jobName',
          data: {
            X: '',
            Y: '',
            MaxWidth: '',
            font: '',
            size: '',
            color: '',
            fontBold: '',
            status: true
          }
        }, {
          name: 'city',
          data: {
            X: '',
            Y: '',
            MaxWidth: '',
            font: '',
            size: '',
            color: '',
            fontBold: '',
            status: true
          }
        }, {
          name: 'companyName',
          data: {
            X: '',
            Y: '',
            MaxWidth: '',
            font: '',
            size: '',
            color: '',
            fontBold: '',
            status: true
          }
        }, {
          name: 'distinct',
          data: {
            X: '',
            Y: '',
            MaxWidth: '',
            font: '',
            size: '',
            color: '',
            fontBold: '',
            status: true
          }
        }, {
          name: 'address',
          data: {
            X: '',
            Y: '',
            MaxWidth: '',
            font: '',
            size: '',
            color: '',
            fontBold: '',
            status: true
          }
        }]
      },
      emptyPosterTemlate: {
        poster_type: '',
        is_enabled: true,
        bg_size: {
          X: '',
          Y: ''
        },
        bg_source_url: '',
        watermark_bg_url: '',
        watermark_bg_location: '',
        share_img_url: '',
        qrcode_configuration: {
          X: '',
          Y: '',
          width: '',
          haveLogo: false,
          roundedCorners: false
        },
        content_configuration: [{
          name: 'jobName',
          data: {
            X: '',
            Y: '',
            MaxWidth: '',
            font: '',
            size: '',
            color: '',
            fontBold: '',
            status: true
          }
        }, {
          name: 'city',
          data: {
            X: '',
            Y: '',
            MaxWidth: '',
            font: '',
            size: '',
            color: '',
            fontBold: '',
            status: true
          }
        }, {
          name: 'companyName',
          data: {
            X: '',
            Y: '',
            MaxWidth: '',
            font: '',
            size: '',
            color: '',
            fontBold: '',
            status: true
          }
        }, {
          name: 'distinct',
          data: {
            X: '',
            Y: '',
            MaxWidth: '',
            font: '',
            size: '',
            color: '',
            fontBold: '',
            status: true
          }
        }, {
          name: 'address',
          data: {
            X: '',
            Y: '',
            MaxWidth: '',
            font: '',
            size: '',
            color: '',
            fontBold: '',
            status: true
          }
        }]
      },
      posterPreviewShow: false,
      posterTitle: '',
      jobPosterType: {
        id: '',
        title: '',
        sort: 0,
        is_disabled: false,
        poster_type: ''
      },
      posterDataEN: null,
      posterDataCN: null,
      painting: null,
      previewPosterUrl: null,
      previewHeight: null,
      previewQrcode: {
        text: 'https://www.ajinga.com/',
        logoSrc: null,
        previewQrcodeUrl: null,
        previewQrcodeUrlWithLogo: null
      },
      posterShowType: 'COMMON',
      companyThemeSetting: null
    }
  },
  components: {
    VueQr,
    VueCanvasPoster,
    RectLoading
  },
  computed: {
    hasAmbassadorPosterPremium () {
      return this.hasAnyPermission('PREMIUM_AMBASSADOR_POSTER')
    },
    posterShowTypeOptions () {
      const list = _.map(JOB_POSTER_SHOW_TYPE, (val, key) => {
        return {
          label: this.$t(`${this.i18nPrefix}.jobPosterShowType.${key}`),
          value: val,
          hidden: (key !== 'COMMON' && !this.hasAmbassadorPosterPremium)
        }
      })
      return _.filter(list, item => !_.includes(this.hiddenVideoPosterShowTypeList, item.value) && !(this.isVideoPoster && item.value === 'INSTRUCTIONS') && !item.hidden)
    },
    companyId () {
      return this.$route.query.companyId
    },
    posterTypeId () {
      return this.$route.query.posterTypeId
    },
    posterType () {
      return this.$route.params.posterType
    },
    isVideoPoster () {
      return this.posterType === 'video'
    },
    selectPosterShowType () {
      return this.$route.query.selectPosterShowType || ''
    },
    hiddenVideoPosterShowTypeList () {
      const hiddenVideoPosterShowType = this.$route.query.hiddenVideoPosterShowType
      if (hiddenVideoPosterShowType) {
        return hiddenVideoPosterShowType.split(',')
      }
      return []
    },
    getBgImageUrl () {
      if (this.isVideoPoster) {
        return this.posterEditData.watermark_bg_url
      } else {
        return this.posterEditData.bg_source_url
      }
    },
    currentImageFile () {
      return this.isCnPoster ? this.uploadImg.imgFileCN : this.uploadImg.imgFileEN
    },
    fontStyle () {
      const commonSetting = this.companyThemeSetting?.commonSetting || {}
      const fontFamilyList = commonSetting.customFont?.fontFamilyList || []
      const fontFamily = _.chain(fontFamilyList).filter(item => item.active).map(item => `"${item.name}"`).value()
      const fontLinkList = []
      const fontFace = _.chain(fontFamilyList).filter(item => item.active && !item.isDefault).map(item => {
        const urls = _.map(item.fileList, file => {
          return `url('${file.url}') format('${file.ext}')`
        }).join(',\n')

        fontLinkList.push({
          rel: 'preload',
          href: item.fileList[0].url,
          as: 'font',
          crossorigin: 'anonymous'
        })

        return `@font-face {
          font-family: "${item.name}";
          src: 
            ${urls};
          font-weight: normal;
          font-style: normal;
        }`
      }).value().join('\n')
      return {
        fontFace: fontFace,
        fontFamily: fontFamily.join(','),
        fontLinkList: fontLinkList
      }
    }
  },
  mounted () {
    window.onbeforeunload = (event) => {
      if (!this.isSavePosterDataCN || !this.isSavePosterDataEN) {
        event.returnValue = this.$t('common.message.unSaveChangeConfirm')
        return event.returnValue
      }
    }
  },
  watch: {
    posterEditData: {
      handler () {
        if (this.isChangeLanguage) {
          this.isChangeLanguage = false
        } else {
          if (this.isCnPoster) {
            this.isSavePosterDataCN = false
          } else {
            this.isSavePosterDataEN = false
          }
        }
        this.updateImageStatus()
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.jobPosterType.poster_type = this.posterType
    this.jobPosterType.company_id = this.companyId
    this.initPage()
  },
  methods: {
    ...mapActions('common', ['compressVideo', 'watermarkVideo', 'getMediaPrefopStatus', 'getMediaInfo']),
    ...mapActions('company', ['getJobPoster', 'updateJobPoster', 'getCompanyTheme']),
    getVideoPosterTypeName (type) {
      return this.$t('admin.company.jobPoster.label.' + type)
    },
    initPage () {
      this.getJobPosterByPosterTypeId()
      this.loadCompanyTheme()
    },
    rowStyle (row) {
      if ((row.row.name === 'distinct' || row.row.name === 'address') && this.isVideoPoster) {
        return { display: 'none' }
      }
      return { height: '45px' }
    },
    async getJobPosterByPosterTypeId () {
      this.showLoadingBox = true
      const posterResp = await this.getJobPoster({ company_id: this.companyId, poster_type_id: this.posterTypeId })
      if (posterResp) {
        const data = posterResp
        this.posterShowType = data.show_type || this.selectPosterShowType || 'COMMON'
        this.jobPosterType = { ...this.jobPosterType, ...data.job_poster_type }
        if (data.job_poster_cn) {
          const posterDataCN = data.job_poster_cn
          posterDataCN.is_enabled = !posterDataCN.is_disabled
          posterDataCN.bg_size = JSON.parse(posterDataCN.bg_size)
          posterDataCN.content_configuration = JSON.parse(posterDataCN.content_configuration)
          posterDataCN.qrcode_configuration = JSON.parse(posterDataCN.qrcode_configuration)
          this.posterDataCN = posterDataCN
        } else {
          this.posterDataCN = _.cloneDeep(this.emptyPosterTemlate)
        }
        if (data.job_poster_en) {
          const posterDataEN = data.job_poster_en
          posterDataEN.is_enabled = !posterDataEN.is_disabled
          posterDataEN.bg_size = JSON.parse(posterDataEN.bg_size)
          posterDataEN.content_configuration = JSON.parse(posterDataEN.content_configuration)
          posterDataEN.qrcode_configuration = JSON.parse(posterDataEN.qrcode_configuration)
          this.posterDataEN = posterDataEN
        } else {
          this.posterDataEN = _.cloneDeep(this.emptyPosterTemlate)
        }
        const urlState = await this.checkUrlIsValid(this.$DjangoBaseUrl(data.company_logo))
        if (urlState) {
          this.previewQrcode.logoSrc = this.$DjangoBaseUrl(data.company_logo)
        } else {
          this.previewQrcode.logoSrc = require('@/assets/image/jobDetail/blank-logo.png')
        }
      }
      if (this.posterDataCN.content_configuration.length <= 3) {
        this.posterDataCN.content_configuration.push({
          name: 'distinct',
          data: {
            X: '',
            Y: '',
            MaxWidth: '',
            font: '',
            size: '',
            color: '',
            fontBold: '',
            status: true
          }
        }, {
          name: 'address',
          data: {
            X: '',
            Y: '',
            MaxWidth: '',
            font: '',
            size: '',
            color: '',
            fontBold: '',
            status: true
          }
        })
      }
      this.posterEditData = _.cloneDeep(this.posterDataCN)
      try {
        await this.setCompressedVideoTempUrl()
      } finally {
        this.isCnPoster = true
        this.saveSourceAndShareImgToLocalStorage()
        this.isSavePosterDataCN = true
        this.isSavePosterDataEN = true
        this.isChangeLanguage = true
        this.showLoadingBox = false
      }
    },
    async loadCompanyTheme () {
      const resp = await this.getCompanyTheme({
        companyId: this.companyId,
        noUseGlobal: true
      })
      if (!_.isEmpty(resp)) {
        this.companyThemeSetting = resp
      }
    },
    checkUrlIsValid (url) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.src = url
        img.onload = (res) => {
          resolve(true)
        }
        img.onerror = () => {
          resolve(false)
        }
      })
    },
    async setCompressedVideoTempUrl () {
      if (!this.isVideoPoster) {
        return
      }
      // eslint-disable-next-line camelcase
      const watermarkLocation = this.posterEditData?.watermark_bg_location
      if (watermarkLocation) {
        this.videoPosterType = watermarkLocation
      }
      // eslint-disable-next-line camelcase
      const videoKey = this.posterEditData?.bg_source_url
      if (!videoKey) {
        this.compressedVideoTempUrl = ''
        return
      }
      this.compressedVideoTempUrl = this.getSourcePath(videoKey)
      await this.setVideoInfo(videoKey)
    },
    saveSourceAndShareImgToLocalStorage () {
      if (!this.posterEditData || !this.posterTypeId) {
        return
      }
      this.setFileKeyToLocalStorage(
        // eslint-disable-next-line camelcase
        [this.posterEditData?.bg_source_url, this.posterEditData?.share_img_url, this.posterEditData?.watermark_bg_url]
      )
    },
    async posterLanguageSelect (status, isCN) {
      this.showLoadingBox = true
      if (this.videoIsGenerating || this.videoIsUploading) {
        this.needBreakOption = true
      }
      if (!status) {
        this.isCnPoster = !this.isCnPoster
        this.posterPreviewShow = false
        this.posterVideoPreviewShow = false
        if (isCN) {
          this.posterDataEN = _.cloneDeep(this.posterEditData)
          this.posterEditData = null
          this.posterEditData = _.cloneDeep(this.posterDataCN)
        } else {
          this.posterDataCN = _.cloneDeep(this.posterEditData)
          this.posterEditData = null
          this.posterEditData = _.cloneDeep(this.posterDataEN)
        }
        this.isChangeLanguage = true
      }
      await this.setCompressedVideoTempUrl()
      this.saveSourceAndShareImgToLocalStorage()
      this.showLoadingBox = false
    },
    async handleSave () {
      if (!this.jobPosterType.title || this.jobPosterType.title.length > 60) {
        this.$message({
          type: 'error',
          showClose: true,
          message: this.$t('admin.company.jobPoster.message.noPosterTitle')
        })
        return
      }
      if (this.isSaving) {
        return
      }
      try {
        this.isSaving = true
        const imgFile = this.isCnPoster ? this.uploadImg.imgFileCN : this.uploadImg.imgFileEN
        if (imgFile) {
          if (imgFile.bgImgFile && imgFile.bgImgFileKey) {
            const bgImageUrl = await this.uploadFileToCDN(imgFile.bgImgFile, imgFile.bgImgFileKey)
            if (this.isVideoPoster) {
              this.posterEditData.watermark_bg_url = bgImageUrl
            } else {
              this.posterEditData.bg_source_url = bgImageUrl
            }
          }
          if (imgFile.shareImgFile && imgFile.shareImgFileKey) {
            this.posterEditData.share_img_url = await this.uploadFileToCDN(imgFile.shareImgFile, imgFile.shareImgFileKey)
          }
        }
        if (this.isVideoPoster) {
          this.posterEditData.watermark_bg_location = this.videoPosterType
          const fileInfo = this.getUploadVideoInfo()
          if (fileInfo && fileInfo.file && fileInfo.fileKey) {
            this.posterEditData.bg_source_url = fileInfo.fileKey
          }
        }
        const poster = _.cloneDeep(this.posterEditData)
        if (this.isVideoPoster && !poster.bg_source_url) {
          this.$message({
            type: 'error',
            showClose: true,
            message: this.$t('admin.company.jobPoster.message.noPosterVideo')
          })
          return
        }
        if (!this.getBgImageUrl) {
          this.$message({
            type: 'error',
            showClose: true,
            message: this.$t('admin.company.jobPoster.message.noPosterBgImage')
          })
          return
        }
        if (!poster.share_img_url) {
          this.$message({
            type: 'error',
            showClose: true,
            message: this.$t('admin.company.jobPoster.message.noPosterShareImage')
          })
          return
        }
        poster.language_code = this.isCnPoster ? 'cn' : 'en'
        poster.company_id = this.companyId
        poster.poster_type = this.posterType
        poster.bg_size = JSON.stringify(poster.bg_size)
        poster.content_configuration = JSON.stringify(poster.content_configuration).toString()
        poster.qrcode_configuration = JSON.stringify(poster.qrcode_configuration).toString()
        poster.invalid_keys = this.getWillDeleteKeys([poster.bg_source_url, poster.share_img_url, poster.watermark_bg_url])
        poster.show_type = this.posterShowType
        const posterResp = await this.updateJobPoster({ poster, job_poster_type: this.jobPosterType })
        if (posterResp.job_poster) {
          this.deleteFileKeyOfLocalStorage()
          this.$message({
            type: 'success',
            showClose: true,
            message: this.$t('admin.company.jobPoster.message.posterSaveSuccess')
          })
          this.jobPosterType.id = posterResp.job_poster.job_poster_type
        } else {
          this.$message({
            type: 'error',
            showClose: true,
            message: this.$t('admin.company.jobPoster.message.posterSaveError')
          })
        }
        if (this.isCnPoster) {
          this.isSavePosterDataCN = true
        } else {
          this.isSavePosterDataEN = true
        }
      } finally {
        this.isSaving = false
      }
    },
    handlePreview (showPreviewPicture = true) {
      this.posterPreviewShow = showPreviewPicture
      // 视频和图片预览只显示一个
      if (showPreviewPicture) {
        this.posterVideoPreviewShow = false
      }
      const imgFile = this.isCnPoster ? this.uploadImg.imgFileCN : this.uploadImg.imgFileEN
      if (!imgFile.bgImgUrl && !this.getBgImageUrl) {
        this.posterPreviewShow = false
        this.$message({
          type: 'error',
          showClose: true,
          message: this.$t('admin.company.jobPoster.message.noPosterBgImage')
        })
      } else {
        if (Number(this.posterEditData.bg_size.Y) < 1 || Number(this.posterEditData.bg_size.X) < 1) {
          this.posterPreviewShow = false
          this.$message({
            type: 'error',
            showClose: true,
            message: this.$t('admin.company.jobPoster.message.posterBgSizeError')
          })
          return
        }
        this.previewHeight = (Number(this.posterEditData.bg_size.Y) / Number(this.posterEditData.bg_size.X)) * 500
        const bgImgUrl = imgFile.bgImgUrl || this.getBgImageUrl
        const painting = {
          width: this.posterEditData.bg_size.X + 'px',
          height: this.posterEditData.bg_size.Y + 'px',
          background: this.getSourcePath(bgImgUrl),
          // backgroundColor: 'rgba(255,255,255,0.2)',
          views: []
        }

        this.posterEditData.content_configuration.forEach(item => {
          if (item.data.status) {
            let fontFamily = item.data.font
            if (item.data.customFont) {
              /**
               *  vue-canvas-poster组件中的fontFamily的值只支持设置单个
               *  去除自定义字体前后的 " 使该组件支持多个fontFamily
               *  例如： vue-canvas-poster组件中fontFamily的应用为 font: 12px "{fontFamily}"
               *      若 fontFamily = "宋体", "Arial", "sans-serif" 则 => font: 12px ""宋体", "Arial", "sans-serif"" 不符合规则
               */
              fontFamily = this.fontStyle.fontFamily.slice(1, -1)
            }
            const viewItem = {
              type: 'text',
              text: this.$t(`admin.company.jobPoster.label.${item.name}`),
              css: {
                left: (item.data.X | 0) + 'px',
                top: (item.data.Y | 0) + 'px',
                fontSize: (item.data.size | 0) + 'px',
                lineHeight: (item.data.size | 0) + 6 + 'px',
                fontFamily: fontFamily,
                width: (item.data.MaxWidth | 0) + 'px',
                color: item.data.color,
                textAlign: item.data.centerAlign ? 'center' : 'left',
                maxLines: 2
              }
            }

            if (item.data.fontBold) {
              viewItem.css.fontWeight = 'bold'
            }
            painting.views.push(viewItem)
          }
        })

        // add qrcode
        const qrcodeConfiguration = this.posterEditData.qrcode_configuration
        const qrcodeView = {
          type: 'image',
          css: {
            width: (qrcodeConfiguration.width | 0) + 'px',
            height: (qrcodeConfiguration.width | 0) + 'px',
            left: (qrcodeConfiguration.X | 0) + 'px',
            top: (qrcodeConfiguration.Y | 0) + 'px'
          }
        }
        if (qrcodeConfiguration.haveLogo) {
          qrcodeView.url = this.previewQrcode.previewQrcodeUrlWithLogo
        } else {
          qrcodeView.url = this.previewQrcode.previewQrcodeUrl
        }
        if (qrcodeConfiguration.roundedCorners) {
          qrcodeView.css.borderRadius = Number(qrcodeConfiguration.width) * 0.05 + 'px'
        }
        painting.views.push(qrcodeView)
        this.painting = painting
      }
    },
    handlePreviewVideo () {
      // 检查待合成的视频
      if (!this.compressedVideoTempUrl) {
        this.$message.error({
          type: 'error',
          showClose: true,
          message: this.$t('admin.company.jobPoster.message.wrongVideoSize', { size: this.acceptVideoSize, duration: this.acceptVideoDuration })
        })
        return
      }
      // 生成水印图片
      this.handlePreview(false)
    },
    savePreviewQRcodeUrl (url, id) {
      if (this.previewQrcode.logoSrc) {
        this.previewQrcode.previewQrcodeUrlWithLogo = url
        this.previewQrcode.logoSrc = null
      } else {
        this.previewQrcode.previewQrcodeUrl = url
      }
    },
    successCreateImg (src) {
      this.previewPosterUrl = src
      // 证明是在预览视频，不显示图片，只合成视频并显示
      if (!this.posterPreviewShow) {
        this.previewVideo(src)
      }
    },
    async previewVideo (previewImageSrc) {
      // 合成图片后,先上传至cdn,并记录图片和视频的key,传给后台用来合成视频。
      this.videoIsGenerating = true
      const fileInfo = this.getUploadVideoInfo()
      const videoFileKey = fileInfo.fileKey || this.posterEditData.bg_source_url
      if (!videoFileKey) {
        return
      }
      if (!this.videoInfo.width) {
        await this.setVideoInfo(videoFileKey)
      }
      const imageFileKey = this.generateFileKey(this.isCnPoster ? 'cn' : 'en', 'videoimage')
      const imageWidth = this.posterEditData.bg_size.X
      const imageHeight = this.posterEditData.bg_size.Y
      if (this.videoPosterType === 'tail') {
        const displayAspectRatio = this.videoInfo.displayAspectRatio
        const aspectHeight = getBindImageHeight(displayAspectRatio, imageWidth, imageHeight)
        const resizeSrcFile = await dataUrlToFile(previewImageSrc, 'test')
        // 压缩预处理图片，否则图片拼接视频不成功
        const blob = await preCompressImage(resizeSrcFile, imageWidth, aspectHeight)
        await this.uploadFileToCDN(blob, imageFileKey)
      } else {
        const resizeSrc = await resizeDataURL(previewImageSrc, imageWidth, imageHeight)
        await uploadBase64Src(imageFileKey, resizeSrc)
        this.setFileKeyToLocalStorage(imageFileKey)
      }
      if (this.needBreak()) {
        return
      }
      // 调后台接口, 传imageFileKey, videoFileKey, videoPosterType, 后台调七牛接口合成视频, 将合成后的视频url传给前台并显示。
      const params = {
        imageKey: imageFileKey,
        videoKey: videoFileKey,
        resolution: this.videoInfo,
        location: this.videoPosterType
      }
      const resp = await this.watermarkVideo(params)
      if (this.needBreak()) {
        return
      }
      const persistentId = resp?.persistentId
      if (persistentId) {
        this.getVideoStatus(persistentId, 'preview', imageFileKey)
      }
    },
    fail () {},
    updateImageStatus () {
      this.hasBgImage = this.getBgImageUrl || this.currentImageFile.bgImgUrl
      this.hasShareImage = this.posterEditData.share_img_url || this.currentImageFile.shareImgUrl
    },
    needBreak () {
      if (!this.needBreakOption) {
        return false
      }
      this.needBreakOption = false
      this.videoIsGenerating = false
      this.videoIsUploading = false
      return true
    },
    async setVideoInfo (videoKey) {
      const resp = await this.getMediaInfo(videoKey)
      if (resp?.streams.length > 0) {
        const newVideoInfo = resp.streams[0]
        this.videoInfo.width = newVideoInfo.width
        this.videoInfo.height = newVideoInfo.height
        this.videoInfo.displayAspectRatio = newVideoInfo.display_aspect_ratio || `${newVideoInfo.width.toString()}/${newVideoInfo.height.toString()}`
      }
    },
    getUploadVideoInfo () {
      const fileInfo = this.isCnPoster ? this.uploadVideo.fileCN : this.uploadVideo.fileEN
      return fileInfo
    },
    handleFontSelect (command, index, type) {
      if (type === 'font' && command === 'followTheme') {
        this.$set(this.posterEditData.content_configuration[index].data, 'customFont', true)
      } else {
        this.$set(this.posterEditData.content_configuration[index].data, 'customFont', false)
      }
      this.$set(this.posterEditData.content_configuration[index].data, type, command)
    },
    handleUploadBtnClick (isBg) {
      let uploadFile = null
      if (isBg) {
        uploadFile = this.$refs.bgImageFile
      } else {
        uploadFile = this.$refs.shareImageFile
      }
      uploadFile.click()
    },
    handleImageFileChange (isBg) {
      let uploadFile = null
      if (isBg) {
        uploadFile = this.$refs.bgImageFile
      } else {
        uploadFile = this.$refs.shareImageFile
      }
      const file = uploadFile.files[0]
      if (!file) {
        return
      }
      if (!ACCEPT_FILE_TYPE.includes(file.type)) {
        this.$message.error({
          type: 'error',
          showClose: true,
          message: this.$t('admin.company.jobPoster.message.wrongImageType')
        })
        return
      }
      if (file.size > ACCEPT_FILE_SIZE) {
        this.$message.error({
          type: 'error',
          showClose: true,
          message: this.$t('admin.company.jobPoster.message.wrongImageSize', { size: 2 })
        })
        return
      }
      const fileTempUrl = window.URL.createObjectURL(file)
      let imgFile = null
      if (this.isCnPoster) {
        imgFile = this.uploadImg.imgFileCN
        imgFile.bgImgFileKey = this.generateFileKey('cn', 'bg')
        imgFile.shareImgFileKey = this.generateFileKey('cn', 'share')
      } else {
        imgFile = this.uploadImg.imgFileEN
        imgFile.bgImgFileKey = this.generateFileKey('en', 'bg')
        imgFile.shareImgFileKey = this.generateFileKey('en', 'share')
      }
      if (isBg) {
        imgFile.bgImgUrl = fileTempUrl
        imgFile.bgImgFile = file
      } else {
        imgFile.shareImgUrl = fileTempUrl
        imgFile.shareImgFile = file
      }
      this.$message({
        type: 'success',
        showClose: true,
        message: this.$t('admin.company.jobPoster.message.uploadSuccess')
      })
      this.updateImageStatus()
    },
    async onVideoLoaded (e) {
      const video = e.target
      this.videoInfo = {
        duration: video.duration,
        width: video.videoWidth,
        height: video.videoHeight
      }
      this.videoIsUploading = true
      this.handleVideoFileAfterLoaded()
      const fileInfo = this.getUploadVideoInfo()
      try {
        if (fileInfo && fileInfo.file && fileInfo.fileKey) {
          await this.uploadFileToCDN(fileInfo.file, fileInfo.fileKey, true)
          if (this.needBreak()) {
            return
          }
          // 调后台接口压缩视频，得到任务id，依据任务id调七牛接口轮询压缩状态，code=0 则压缩成功
          const params = {
            videoKey: fileInfo.fileKey,
            resolution: this.getMaxResolution(this.videoInfo)
          }
          const resp = await this.compressVideo(params)
          if (this.needBreak()) {
            return
          }
          const persistentId = resp?.persistentId
          if (persistentId) {
            this.getVideoStatus(persistentId, 'compress')
          }
        }
      } catch (error) {
        this.$message({
          type: 'error',
          showClose: true,
          message: this.$t('admin.company.jobPoster.message.uploadFailed')
        })
      }
    },
    is2K (resolution) {
      return Math.max(resolution.width, resolution.height) >= 2048
    },
    getMaxResolution (resolution) {
      const p1080 = { width: 1920, height: 1080 }
      if (!this.is2K(resolution)) {
        return resolution
      }
      if (resolution.width >= resolution.height) {
        p1080.height = p1080.width * resolution.height / resolution.width
      } else {
        p1080.width = p1080.height * resolution.width / resolution.height
      }
      return p1080
    },
    getVideoStatus (persistentId, videoType, imageKey) {
      setTimeout(async () => {
        const resp = await this.getMediaPrefopStatus({ persistentId })
        if (this.needBreak()) {
          return
        }
        if (resp.code > 2) {
          this.$message({
            type: 'error',
            showClose: true,
            message: this.$t('admin.company.jobPoster.message.operateFailed')
          })
          this.videoIsGenerating = false
          this.videoIsUploading = false
          return
        }
        if (resp.code !== 0) {
          this.getVideoStatus(persistentId, videoType, imageKey)
          return
        }
        this.videoIsUploading = false
        if (resp?.items.length > 0) {
          const newVideoKey = resp.items[0].key
          const newVideoUrl = this.getSourcePath(newVideoKey)
          this.setFileKeyToLocalStorage(newVideoKey)
          if (videoType === 'preview') {
            // 合成视频
            this.previewVideoTempUrl = newVideoUrl
            this.posterVideoPreviewShow = true
            // 视频和图片预览只显示一个
            this.posterPreviewShow = false
            this.videoIsGenerating = false
            return
          }
          // 压缩视频后续操作
          const fileInfo = this.isCnPoster ? this.uploadVideo.fileCN : this.uploadVideo.fileEN
          fileInfo.fileKey = newVideoKey
          this.compressedVideoTempUrl = newVideoUrl
          await this.setVideoInfo(newVideoKey)
          this.$message({
            type: 'success',
            showClose: true,
            message: this.$t('admin.company.jobPoster.message.uploadSuccess')
          })
        }
      }, 2000)
    },
    getFileKeyFromLocalStorage () {
      // 将不同海报分开操作，互不影响，否则可能会出现资源被误删除
      // {
      //   'cn': { company_id: { 'posterTypeId1': [], 'posterTypeId2': [] } },
      //   'en': { company_id: { 'posterTypeId3': [], 'posterTypeId4': [] } }
      // }
      let result = { cn: {}, en: {} }
      const resultString = localStorage.getItem(LOCAL_FILE_KEY)
      if (resultString) {
        result = JSON.parse(resultString)
      }
      return result
    },
    setFileKeyToLocalStorage (keys) {
      if (!keys || !this.posterTypeId) {
        return
      }
      if (!Array.isArray(keys)) {
        keys = [keys]
      }
      const uniqueKeys = []
      const currentKeys = this.getFileKeyFromLocalStorage()
      let company = (this.isCnPoster ? currentKeys.cn[this.companyId] : currentKeys.en[this.companyId]) || {}
      if (Array.isArray(company)) {
        company = {}
      }
      const targetKeyList = (company && company[this.posterTypeId]) || []
      keys.forEach((key) => {
        if (!targetKeyList.includes(key) && key) {
          uniqueKeys.push(key)
        }
      })
      targetKeyList.push(...uniqueKeys)
      if (this.isCnPoster) {
        if (!currentKeys.cn[this.companyId]) {
          currentKeys.cn[this.companyId] = {}
        }
        currentKeys.cn[this.companyId][this.posterTypeId] = targetKeyList
      } else {
        if (!currentKeys.en[this.companyId]) {
          currentKeys.en[this.companyId] = {}
        }
        currentKeys.en[this.companyId][this.posterTypeId] = targetKeyList
      }
      localStorage.setItem(LOCAL_FILE_KEY, JSON.stringify(currentKeys))
    },
    deleteFileKeyOfLocalStorage () {
      const currentKeys = this.getFileKeyFromLocalStorage()
      const company = (this.isCnPoster ? currentKeys.cn[this.companyId] : currentKeys.en[this.companyId]) || {}
      const targetKeyList = (company && company[this.posterTypeId]) || []
      targetKeyList.length = 0
      localStorage.setItem(LOCAL_FILE_KEY, JSON.stringify(currentKeys))
    },
    getWillDeleteKeys (willSaveKeys) {
      if (!Array.isArray(willSaveKeys)) {
        willSaveKeys = [willSaveKeys]
      }
      const currentKeys = this.getFileKeyFromLocalStorage()
      const company = (this.isCnPoster ? currentKeys.cn[this.companyId] : currentKeys.en[this.companyId]) || {}
      const targetKeyList = (company && company[this.posterTypeId]) || []
      return targetKeyList.filter((item) => !willSaveKeys.includes(item))
    },
    handleUploadVideoBtnClick () {
      const uploadFile = this.$refs.videoFile
      uploadFile.click()
    },
    handleVideoFileChange () {
      const uploadFile = this.$refs.videoFile
      const file = uploadFile.files[0]
      this.videoTempUrl = window.URL.createObjectURL(file)
    },
    handleVideoFileAfterLoaded () {
      const uploadFile = this.$refs.videoFile
      const file = uploadFile.files[0]
      if (!file || !ACCEPT_VIDEO_FILE_TYPE.includes(file.type) || file.size > (ACCEPT_FILE_SIZE * 1024 * 1024) || this.videoInfo.duration > ACCEPT_VIDEO_DURATION_SECONDS) {
        this.$message.error({
          type: 'error',
          showClose: true,
          message: this.$t(
            'admin.company.jobPoster.message.wrongVideoSize'
            , { size: this.acceptVideoSize, duration: this.acceptVideoDuration }
          )
        })
        this.clearVideoUrl()
        return false
      }
      if (this.isCnPoster) {
        const existKey = this.companyVideoKeyMap.cn[this.companyId] || this.generateVideoKey('cn', 'video')
        this.uploadVideo.fileCN.fileKey = existKey
        this.companyVideoKeyMap.cn[this.companyId] = existKey
        this.uploadVideo.fileCN.file = file
      } else {
        const existKey = this.companyVideoKeyMap.en[this.companyId] || this.generateVideoKey('en', 'video')
        this.uploadVideo.fileEN.fileKey = existKey
        this.companyVideoKeyMap.en[this.companyId] = existKey
        this.uploadVideo.fileEN.file = file
      }
      this.uploadVideo.file = file
      return true
    },
    clearVideoUrl () {
      this.videoInfo = {}
      this.videoTempUrl = ''
    },

    async uploadFileToCDN (file, fileKey, isVideo) {
      // const fileKey = this.generateFileKey(file)
      // 覆盖上传
      // const tokenResp = await this.getQiniuUploadToken({ is_public: true, key: fileKey })
      // this.uploadImg.token = tokenResp.token
      const uploadMode = `job_poster_${isVideo ? 'video' : 'image'}`
      return uploadFileUtil(file, fileKey, true, null, uploadMode).then(resp => {
        this.setFileKeyToLocalStorage(fileKey)
        return fileKey
      }).catch(resp => {
        if (resp && resp.message) {
          this.$message.error({
            type: 'error',
            showClose: true,
            message: this.$t('admin.crm.survey.message.uploadError')
          })
        }
        return resp
      })
    },
    getSourcePath (path) {
      if (!path || path.includes('http')) {
        return path
      } else {
        return `${process.env.VUE_APP_QINIU_DOMAIN}${path}?v=${new Date().getTime()}`
      }
    },
    generateFileKey (language, type) {
      return `${this.uploadImg.fileKeyPrefix}${this.companyId}-${language}-${type}-${new Date().valueOf()}`
    },
    generateVideoKey (language, type) {
      return `${this.uploadVideo.fileKeyPrefix}${this.companyId}-${language}-${type}-${new Date().valueOf()}`
    },
    formatCompanyData (data, company, companyList) {
      companyList.push(company)
      const allChildren = data.children
      const children = allChildren[company.id]
      if (children && children.length > 0) {
        for (const child of children) {
          this.formatCompanyData(data, child, companyList)
        }
      }
      return companyList
    },
    formatFontSize (value, data) {
      data.size = value.replace(/[^0-9]/g, '')
    },
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.job-poster {
  .header {
    height: 90px;
    .header-left {
      .text {
        color: #666666;
        font-size: 16px;
        font-weight: bold;
      }
      .el-input {
        margin-top: 10px;
      }
    }
    .header-right {
      text-align: right;
      .status-container {
        display: block;
        height: 35px;
        .el-switch {
          &.is-checked {
            ::v-deep .el-switch__core {
              &::after {
                  margin-left: -22px;
              }
            }
          }
          ::v-deep {
            .el-switch__label {
              display: none;
              position: absolute;
              &.is-active {
                display: inline-block;
              }
              &--left {
                color: #5a5a5a;
                position: absolute;
                right: 2px;
                top: 1px;
                z-index: 1;
              }
              &--right {
                color: #fff;
                position: absolute;
                left: 4px;
                top: 1px;
              }
            }
            .el-switch__core {
              height: 25px;
              border-radius: 14px;
              &::after {
                width: 21px;
                height: 21px;
              }
            }
          }
        }
      }
      .poster-select {
        display: block;
        height: 55px;
        font-size: 16px;
        line-height: 20px;
        color: #0096cc;
        cursor: pointer;
      }
      .poster-language-selected{
        color: #666666;
      }
    }
  }
  .content {
    .poster-management {
      position: relative;
      .rect-loading {
        position: absolute;
      }
      .poster-bg-img,
      .poster-share-img {
        height: 60px;
        padding: 10px 0;
        .upload-btn {
          height: 30px;
          line-height: 30px;
          font-size: 13px;
          padding: 0 7px;
          border: 1px solid #a2a2a9;
          border-radius: 4px;
          text-align: center;
          width: 100px;
          color: #606266;
          cursor: pointer;
        }
        .img-tips {
          color: #606266;
          cursor: default;
        }
        .poster-type-selector {
          ::v-deep .el-input__icon {
            line-height: 0;
          }
        }
        .notice-icon {
          margin-left: 12px;
          font-size: 16px;
          color: #000000;
        }
        .upload-tip {
          color: #0096cc;
        }
        .upload-status-icon {
          color: #0096cc;
          font-size: 16px;
          margin-left: 15px;
        }
      }
      .video-container {
        video {
          max-width: 660px;
          max-height: 360px;
        }
      }

      .select-poster-show-type {
        margin-bottom: 24px;
        width: 50%;
        display: flex;
        align-items: center;
        .label {
          font-size: 14px;
          color: #666666;
          font-weight: bold;
          display: block;
          width: 33.3%;
        }
      }
      .poster-text {

        .poster-text-table {
          border: 1px solid #8c8c8d;

          .is-text-center {
            display: inline-block;
            vertical-align: middle;

            .checkbox {
              display: inline-block;
              vertical-align: middle;
              margin-right: 3px;
            }

            .qr-text {
              display: inline-block;
              vertical-align: middle;
            }
          }
        }
        .el-dropdown-link {
          cursor: pointer;
        }
        .el-icon-arrow-down {
          font-size: 12px;
          line-height: 30px;
        }
        .color-picker {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          .color-picker-text {
            position: absolute;
            top: 8px;
            font-size: 14px;
          }
          .el-color-picker__icon,
          .el-color-picker__icon::before,
          .el-icon-arrow-down::before {
            display: none;
          }
          ::v-deep {
            .el-color-picker__color-inner {
              width: 16px;
              margin-left: 4px;
            }
          }
        }
        .status-container {
          position: relative;
          .el-switch {
            &.is-checked {
              ::v-deep .el-switch__core {
                &::after {
                    margin-left: -19px;
                }
              }
            }
            ::v-deep {
              .el-switch__label {
                display: none;
                position: absolute;
                &.is-active {
                  display: inline-block;
                }
                &--left {
                  color: #5a5a5a;
                  position: absolute;
                  right: 2px;
                  top: 0;
                  z-index: 1;
                }
                &--right {
                  color: #fff;
                  position: absolute;
                  left: 4px;
                  top: 0;
                }
              }
              .el-switch__core {
                height: 20px;
                border-radius: 10px;
                &::after {
                  width: 18px;
                  height: 18px;
                  margin-top: -1px;
                }
              }
              .el-switch__label span {
                font-size: 12px;
              }
            }
          }
        }
        .poster-dropdown-select::after {
          content: '';
          display: block;
          clear: both;
        }
        .dropdown-text-area {
          display: block;
          float: left;
          width: 42px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          line-height: 30px;

          ::v-deep {
            .el-input__inner {
              border: 0;
              background-color: transparent;
              text-align: center;
              color: #606266;

              &::placeholder {
                font-size: 14px;
                color: #606266;
              }
            }
          }
        }
        .font-bold-option {
          cursor: pointer;
          color: #606266;
        }
        .filed-value {
          word-break: break-word;
        }
      }
      .poster-qrcode {
        .poster-qrcode-size {
          height: 60px;
          padding-top: 40px;
          .qr-text {
            font-size: 14px;
            color: #606266;
          }
        }
      }
      .bottom-btn-group {
        margin-top: 20px;
        display: flex;
        align-items: center;
        span {
          margin-left: 20px;
          color: #0096cc;
        }
        .el-button {
          padding: 8px 20px;
          &:last-child {
            margin-left: auto;
            margin-right: 0;
          }
        }
      }
      .title {
        font-size: 14px;
        color: #666666;
        font-weight: bold;
      }
    }
    .poster-preview {
      .poster-img{
        margin-left: 88px;
        margin-top: 30px;
      }
    }
  }

  ::v-deep {
    .el-select {
      width: unset;
    }
    .adapt-wrapper .el-table td .cell {
      padding: 0px 5px;
    }
    .el-divider--vertical {
      background-color: #666666;
      height: 18px;
    }
    .content {
      .poster-management {
        .el-input__inner {
          height: 30px;
          line-height: 30px;
          font-size: 13px;
          padding: 0 7px;
          border-color: #a2a2a9;
        }
        .el-color-picker__trigger {
          border: none;
          .el-color-picker__color {
            border: none;
          }
          .el-color-picker__icon,
          .el-color-picker__icon::before,
          .el-icon-arrow-down::before,
          .el-color-picker__empty::before{
            display: none;
          }
          .el-color-picker__color-inner {
            width: 15px;
            height: 2px;
            margin-top: 23px;
            margin-left: 3px;
          }
        }
        input[type=number]::-webkit-inner-spin-button,
        input[type=number]::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      }
    }
  }
}
.el-dropdown-menu__item:focus,.el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #e5e5e6;
    color: #8c8c8d
}
.font-select {
  padding: 0;
  margin: 0;
  width: 150px;
  max-height: 150px;
  overflow-y: scroll;
  margin-left: 85px;
  .popper__arrow {
    display: none;
  }
  .el-dropdown-menu__item {
    line-height: 27px;
    padding: 0 5px;
  }
}
.font-size-select {
  padding: 0;
  margin: 0;
  width: 150px;
  max-height: 150px;
  overflow-y: scroll;
  margin-left: 85px;
  .popper__arrow {
    display: none;
  }
  .el-dropdown-menu__item {
    padding: 0 5px;
  }
}
</style>
